import React, { useState, useEffect } from 'react';
import { contentAPI } from '../utils/api';
import { story as fallbackData } from '../utils/mockData';

const Story = () => {
  const [story, setStory] = useState(fallbackData);

  useEffect(() => {
    const fetchData = async () => {
      const data = await contentAPI.getStory();
      if (data && data.title) {
        setStory(data);
      }
    };
    fetchData();
  }, []);

  return (
    <section id="story" className="py-12 bg-gradient-to-b from-[#F5EBE0] to-[#f8fafc] relative">
      <div className="max-w-6xl mx-auto px-6 relative z-10">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          {/* Text Content */}
          <div>
            <h2
              className="text-5xl md:text-6xl mb-6"
              style={{ fontFamily: 'var(--font-serif)' }}
            >
              {story.title}
            </h2>
            <p className="text-xl mb-6 text-gray-700" style={{ fontFamily: 'var(--font-serif)', fontWeight: 600 }}>
              {story.subtitle}
            </p>
            {story.content.map((paragraph, index) => (
              <p key={index} className="text-lg leading-relaxed mb-4 text-gray-800">
                {paragraph}
              </p>
            ))}
          </div>

          {/* Image */}
          <div className="relative">
            <div className="rounded-xl overflow-hidden shadow-2xl">
              <img
                src={story.image_url || "/api/upload/images/b57dd0389093441f8ae04dcbc70eabef.jpg"}
                alt={story.title || 'Our Story'}
                className="w-full h-[600px] object-cover transform hover:scale-105 transition-transform duration-700"
                data-testid="story-image"
              />
            </div>
            {/* Decorative element */}
            <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-[#D4A574] rounded-lg -z-10"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Story;
